import {  useState, useEffect } from "react";

export const isEmpty = (value) => {
  return (
    value == null || (typeof value === "string" && value.trim().length === 0)
  );
};

export function useRootFontSize() {
    const getSize = () =>
        parseFloat(getComputedStyle(document.documentElement).fontSize);

    const [size, setSize] = useState(getSize);

    useEffect(() => {
        let timeout;

        const handleResize = () => {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                const newSize = getSize();

                setSize(current =>
                    current !== newSize ? newSize : current
                );
            }, 100);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            clearTimeout(timeout);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return size;
}